export default __webpack_public_path__ + "static/media/img-0229-netherlands-half-face.e5000ea4.png";